namespace GeniuzPOS.InitialData {
    export interface IcWhsForm {
        WhsId: Serenity.StringEditor;
        WhsName: Serenity.StringEditor;
        WhsType: Serenity.EnumEditor;
        ShopId: Serenity.LookupEditor;
    }

    export class IcWhsForm extends Serenity.PrefixedContext {
        static formKey = 'InitialData.IcWhs';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!IcWhsForm.init)  {
                IcWhsForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.EnumEditor;
                var w2 = s.LookupEditor;

                Q.initFormType(IcWhsForm, [
                    'WhsId', w0,
                    'WhsName', w0,
                    'WhsType', w1,
                    'ShopId', w2
                ]);
            }
        }
    }
}
